export const investorOverviewQueryKeys = {
  all: ['investorOverview'] as const,
  metrics: (investorId?: string) =>
    [...investorOverviewQueryKeys.all, 'metrics', { investorId }] as const,
  overview: () => [...investorOverviewQueryKeys.all, 'overview'] as const,
}
